// Copy and the blank sentinel for the Batch leads grid's sort and filter
// (`leadGridSortFilter`, `SearchFilterDropdown`). A leaf module, so the two
// can share it without importing each other.

/** Filter value for "(Blank)" / "Only blank". NUL-prefixed, so it can never
 *  collide with a real value (Postgres text cannot hold a NUL byte). */
export const BLANK = '\u0000blank';

export const GRID_COPY = {
  blankOption: '(Blank)',
  containsPlaceholder: 'Contains…',
  onlyBlank: 'Only blank',
  reset: 'Reset',
  ok: 'OK',
  hasOpenTasks: 'Has open tasks',
  noOpenTasks: 'No open tasks',
  noNotes: 'No notes',
  loadAll: 'Load all',
  /** A CRM lens's row count: "12 of 300 leads" (the lens shows a subset of the event). */
  lensCount: (shown: number, loaded: number) =>
    `${shown.toLocaleString()} of ${loaded.toLocaleString()} leads`,
  loading: 'Loading…',
  retry: 'Retry',
  /** "Filtering the 50 loaded of 312 leads" / "Filtering the 50 loaded leads". */
  loadedCue: (loaded: number, total: number | null) =>
    total === null
      ? `Filtering the ${loaded.toLocaleString()} loaded leads`
      : `Filtering the ${loaded.toLocaleString()} loaded of ${total.toLocaleString()} leads`,
} as const;
